import { AudienceParcoursHub } from '../../../components/parcours/AudienceParcoursHub';
import { PROCESS_AG_COPROPRIETES } from '../../../config/process-ag-coproprietes';

export default function CoproprieteProcessAgHubPage() {
  return (
    <AudienceParcoursHub
      audienceId="coproprietes"
      segment="process-ag"
      segmentLabel="Process AG"
      items={PROCESS_AG_COPROPRIETES}
      heroEyebrow="Préparer & voter · loi du 10 juillet 1965"
      heroHeadline="Faire voter votre projet"
      heroHeadlineAccent="en assemblée générale"
      heroIntro="Un projet de rénovation d'ampleur ne se vote pas par hasard. Note explicative, projet de résolution, stratégie de vote en 1ère convocation et articulation avec le Plan Pluriannuel de Travaux (loi Climat 2021, art. 171) : voici les quatre étapes pour sécuriser le passage en AG."
      primaryCta={{ label: 'Diagnostic CEE copro', href: '/coproprietes/diagnostic-cee' }}
      secondaryCta={{ label: 'Voir les aides copro', href: '/coproprietes/aides' }}
      bullets={['Loi du 10 juillet 1965', 'PPT loi Climat 2021', 'Sources juridiques citées']}
      gridEyebrow="4 étapes clés"
      gridTitle="Le process AG copropriété pas à pas"
      ctaFinalTitle="Sécuriser le vote de votre projet en AG"
      ctaFinalDescription="Notre équipe accompagne le syndic et le conseil syndical pour structurer la convocation, rédiger les résolutions et anticiper la stratégie de vote — sans se substituer à votre syndic."
    />
  );
}
